import { Document, useCreateDirectUploadsMutation } from '@graphql/generated';
import {
  getFileInfoPromises,
  uploadFilesAsync,
  createDirectUploadAttributesFromFileInfo,
} from '@utils/fileUtils';

import type { UploadProgressData } from 'expo-file-system/legacy';

const useFileProcessor = () => {
  const [createDirectUploads] = useCreateDirectUploadsMutation();

  const processFiles = async (
    documents: Document[],
    callback?: (
      documentClientId: string,
      uploadProgress: UploadProgressData,
      blobId?: string
    ) => void,
    isDeleteFileAfterSuccess?: boolean
  ): Promise<{ blobId: string; clientId: string; numericBlobId: string }[]> => {
    isDeleteFileAfterSuccess ??= true;
    let fileInfoResults: any[] = [];

    return getFileInfoPromises(documents)
      .then((fileInfo) => {
        fileInfoResults = fileInfo;
        return fileInfo;
      })
      .then(await createDirectUploadAttributesFromFileInfo)
      .then((directUploads) => {
        const attr = directUploads.filter(
          ({ byteSize, checksum, filename, clientId }) => {
            // these fields are required
            if (
              byteSize &&
              checksum &&
              checksum.trim() !== '' && // check for empty string
              filename &&
              clientId
            ) {
              return true;
            } else {
              console.log('Cannot upload the file ', filename);
            }
          }
        );

        if (attr.length > 0) {
          return createDirectUploads({
            variables: {
              attributes: attr,
            },
          });
        } else {
          return Promise.resolve({ data: undefined });
        }
      })
      .then(({ data }) => {
        const { createDirectUploads: createDirectUploadsData } = data || {
          createDirectUploads: [],
        };
        return uploadFilesAsync(
          createDirectUploadsData,
          documents,
          fileInfoResults,
          callback,
          isDeleteFileAfterSuccess
        );
      });
  };

  return { processFiles };
};

export default useFileProcessor;
